import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { ShowAttributeTable } from "./BlockTabs/show-attribute-table"
import ShippingInfo from "./ShippingInfo"
import classes from "./product-detail-and-shipping.module.css"

const toHTML = (str: string) => ({
  __html: str,
})

export function ProductDetailAndShipping({ productDetails, product }: any) {
  const hasShowAttribute =
    Array.isArray(product.show_attribute) && product.show_attribute.length > 0

  return (
    <Accordion type="multiple" className="w-full" defaultValue={[]}>
      {productDetails.description ? (
        <AccordionItem value="item-4">
          <AccordionTrigger className="text-normal border-b-1 border-b-[#EFEFEF] font-poppins font-[600] leading-[50px] text-title lg_text-[20px]">
            <h2>Product Description</h2>
          </AccordionTrigger>
          <AccordionContent>
            <div
              className={classes.description}
              dangerouslySetInnerHTML={toHTML(productDetails.description)}
            />
          </AccordionContent>
        </AccordionItem>
      ) : null}
      {hasShowAttribute ? (
        <AccordionItem value="item-1">
          <AccordionTrigger className="text-normal border-b-1 border-b-[#EFEFEF] font-poppins font-[600] leading-[50px] text-title lg_text-[20px]">
            <h2>Specifications</h2>
          </AccordionTrigger>
          <AccordionContent>
            <div className="pt-[20px] font-sans leading-[1.4] text-[#222]">
              <ShowAttributeTable data={product.show_attribute} />
            </div>
          </AccordionContent>
        </AccordionItem>
      ) : null}

      <AccordionItem value="item-3">
        <AccordionTrigger className="text-normal border-b-1 border-b-[#EFEFEF] font-poppins font-[600] leading-[50px] text-title lg_text-[20px]">
          <h2>Shipping & Returns</h2>
        </AccordionTrigger>
        <AccordionContent>
          <ShippingInfo className="pt-[20px] font-sans leading-[1.4] text-[#222]" />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
